import { Component, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BancoService } from 'src/app/services/banco.service';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { Router } from '@angular/router';
import { ModalDestinoDepositoComponent } from './modal-destino-deposito/modal-destino-deposito.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { TipoChequeService } from 'src/app/services/tipo-cheque.service';
import { debounceTime, filter } from 'rxjs/operators';
import { FileDownloadService } from "src/app/shared/services/file-download.service";

@Component({
  selector: 'app-deposito-documentos',
  templateUrl: './deposito-documentos.component.html',
  styleUrls: ['./deposito-documentos.component.scss'],
  providers: [SecurityService],
})
export class DepositoDocumentosComponent implements OnInit {

  @ViewChild(ModalDestinoDepositoComponent, { static: true }) modalDestinoDeposito: ModalDestinoDepositoComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @Output() onClienteChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  private currentPayload: any = null
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  optionsBanco: Array<any> = [];
  optionsCuenta: Array<any> = [];
  docSeleccionado: number
  montoToltalSeleccion: number
  montoToltal: number
  // Constants
  readonly RB_TIPO_FECHA_REGISTRO: Boolean = true //"_RB_TIPO_FECHA_REGISTRO_"
  readonly RB_TIPO_FECHA_VENCIMIENTO: boolean = false //"_RB_TIPO_FECHA_VENCIMIENTO_"

  clienteSeleccionado: any = null
  headerData: any = {}
  // Utils
  private log: any
  optionsTipoCheque: Array<any> = [];

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bancoService: BancoService,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private toastService: ToastService,
    private datesService: DatesService,
    private pagoService: PagoService,
    private depositoDocumentoService: DepositoDocumentoService,
    private router: Router,
    private tipoChequeService: TipoChequeService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('DEPOSITO-DOCUMENTO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    this.optionsCuenta = [
      { value: "1", label: "Gasto" },
      { value: "2", label: "Tipo Operación 2" },
      { value: "3", label: "Tipo Operación 3" },
    ];
    this.loadBancos()

    this.createForm()
    this.tiposCheques()
    this.formChangesSubscriptions()
  }

  loadBancos() {
    this.bancoService.obtenerSegunFiltro('', true, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsBanco = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      bancos: [[]],
      tipoVista: [this.RB_TIPO_FECHA_VENCIMIENTO],
      rutCliente: [null],
      tiposCheque: [[]],
      nroDoc: [null],
      filtroMonto: [null]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
        this.modalSeleccionarCliente.cleanLast()
      })
  }
  private tiposCheques() {
    this.tipoChequeService.GetTiposCheques(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoCheque = registros.filter(tipo =>
        tipo.codigo !== 7 && tipo.codigo !== 8 && tipo.codigo !== 9)
        .map(tipo => ({
          value: tipo.codigo,
          label: tipo.nombre,
          ...tipo
        }))
    })
  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.docSeleccionado = null
    this.montoToltalSeleccion = null
    this.montoToltal = null
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
        bancos: this.formHeader.get('bancos').value,
        cliente_proveedor_rut: Number(this.clienteSeleccionado === null ? 0 : this.clienteSeleccionado.rut),
        numero_doc: Number(this.formHeader.get('nroDoc').value !== null ? this.formHeader.get('nroDoc').value : 0),
        listaTipoCheque: this.formHeader.get('tiposCheque').value,
        filtroMonto: Number(this.formHeader.get('filtroMonto').value === null ? 0 : this.formHeader.get('filtroMonto').value),
      },
      tipo_busquedad: this.formHeader.get('tipoVista').value,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.pagoService.obtenerChequeDeposito(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta

      this.listaMovimientosAll = registros

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.additionalInfo.rutClienteFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
        mov.additionalInfo.index = index
        mov.seleccion = false
      });

      this.showPage(this.paginationContext.CurrentPage)
      this.loading = false
      this.montoToltal = _.sumBy(this.listaMovimientosAll, 'monto')
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  checkAllChange({ checked }) {
    this.listaMovimientosAll
      .filter(mov => mov.estado_codigo === 6 || mov.estado_codigo === 4)
      .forEach(mov => {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      })
    this.listaMovimientos
      .filter(mov => mov.estado_codigo === 6 || mov.estado_codigo === 4)
      .forEach(mov => {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      })
    this.montoToltalSeleccion = 0
    this.docSeleccionado = 0
    this.cantidadSeleccionada()
  }

  checkDetalle({ index, checked }) {
    const selectedMain: any = this.listaMovimientosAll.filter(p => p.additionalInfo.index === index)[0]
    selectedMain.additionalInfo.checked = !checked

    const selected = this.listaMovimientos.filter(p => p.additionalInfo.index === index)[0]
    selected.seleccion = !checked
    selected.additionalInfo.checked = !checked
    this.docSeleccionado = 0
    this.montoToltalSeleccion = 0
    this.cantidadSeleccionada()
  }

  depositarDocumentos() {
    const selected = (_.cloneDeep(this.listaMovimientosAll)).filter(mov => mov.seleccion)
    if (selected.length === 0) {
      this.toastService.error('Seleccione registro(s)')
      return
    }

    selected.forEach(mov => {
      delete mov.additionalInfo
      delete mov.__typename
      delete mov.estado_codigo
      delete mov.estado_nombre
    });

    const inputParams = {
      entidad: {
        lista: selected
      },
      paginaActual: 1, // this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: selected.length //  this.paginationContext.PagesCount
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.depositoDocumentoService.depositarDocumentosDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      // const { registros, totalPaginas, totalRegistros } = respuesta
      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      // this.toastService.success('Operación exitosa')
      // this.router.navigate(['/finanzas/destinoDeposito', index])
      this.modalDestinoDeposito.load(respuesta)
    })

    this.depositoDocumentoService.depositarDocumentosResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      // const { registros, totalPaginas, totalRegistros } = respuesta
      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      // this.toastService.success('Operación exitosa')
      // this.router.navigate(['/finanzas/destinoDeposito', index])
      this.modalDestinoDeposito.loadResumen(respuesta)
    })

  }
  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.formHeader.get('rutCliente').setValue(this.clienteSeleccionado.rutFormato)
    this.onClienteChange.emit(this.headerData.clienteSeleccionado)
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
    this.clearClientData()
  }
  clearClientData() {
    this.clearContent()
    this.onClienteChange.emit(null)
  }
  clearContent() {
    this.headerData = {}
    //this.formValidatorsService.reset(this.formHeader)
  }

  limpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader.reset();
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("rutCliente").setValue(null)
    this.formHeader.get("bancos").setValue([])
    this.formHeader.get("tiposCheque").setValue([])
    this.formHeader.get("nroDoc").setValue(null)
    this.formHeader.get("filtroMonto").setValue(null)
    this.formHeader.get("tipoVista").setValue(this.RB_TIPO_FECHA_VENCIMIENTO)
    this.clienteSeleccionado = null

    this.listaMovimientos = null
    this.listaMovimientosAll = null
    this.docSeleccionado = 0
    this.montoToltalSeleccion = 0

  }

  cantidadSeleccionada() {
    let cont = 1
    this.listaMovimientosAll.forEach(mov => {
      if (mov.seleccion === true) {
        this.docSeleccionado = cont
        cont++
        this.montoToltalSeleccion = this.montoToltalSeleccion + mov.monto
      }
    })
  }

  checkAllChangeStart({ checked }) {

    this.listaMovimientosAll.forEach(mov => {
      if (mov.impresion_doc == false) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      }
    })
    this.listaMovimientos.forEach(mov => {
      if (mov.impresion_doc == false) {
        mov.seleccion = checked
        mov.additionalInfo.checked = checked
      }
    })
    this.docSeleccionado = 0
    this.cantidadSeleccionada()
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.pagoService.obtenerChequeDepositoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
}
